/* eslint-disable import/no-anonymous-default-export */
import ctx from "../../plugins/axios";
export default async () => {
  return await ctx.get("/therapeutic?therapeutic=all");
};
